const nestedFLoor = {
  marginLeft: 0,
  paddingLeft: 32
  // background: '#fff',
  // backgroundColor: '#fff',
  // marginBottom: 1
};

export const activeIconColor = 'rgb(78, 163, 216)';

const style = {
  activeBuilding: {
    // backgroundColor: 'rgba(78, 163, 216, 0.1)',
    // borderRight: '7.5px solid #d9d9d9',
    fontWeight: 'bold',
    color: 'rgb(78, 163, 216)'
  },
  nestedFloor: nestedFLoor,
  activeFloor: {
    backgroundColor: 'rgba(78, 163, 216, 0.2)',
    borderLeft: '5px solid rgb(78, 163, 216)'
    // fontWeight: 'bold'
  },
  // activeIcon: {
  //   color: activeIconColor
  // },
  nestedFloors: {
    padding: '3px 0 7px 0',
    backgroundColor: '#ededed'
  },
  newBuilding: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0
  }
};

export default style;



// WEBPACK FOOTER //
// ./src/components/Sidebar/SidebarMap/SidebarItemFloor/style.js